export default {
	calendars: state => state.calendars,

	findLinkedPartner(state) {
		return partnerId =>
			state.linkedPartners.find(partner => partner.id === partnerId) ||
			null
	},

	firstCalendarId(state) {
		const sorted = [...state.calendars].sort((a, b) =>
			(a.name || '').localeCompare(b.name || '', undefined, {
				sensitivity: 'base',
			})
		)

		return sorted[0]?.id ?? null
	},

	hasCalendars: state => state.calendars.length > 0,

	isBootstrapped: state => state.bootstrapped,

	isLoading: state => state.loading,

	linkedPartners: state => state.linkedPartners,

	officeHoursStatus: state => state.officeHoursStatus,

	officeNumber: state => state.officeNumber,

	partnerName: state => state.partnerName,

	shortId: state => state.shortId,

	timezone: state => state.timezone,
}
